import { OnboardingProgressService } from '@weave/schema-gen-ts/dist/schemas/insys/onboarding/v1/onboarding-progress/onboarding_progress.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaOnboardingProgressV1Service = bindHTTP(OnboardingProgressService);
export const serviceName = 'onboarding-progress-v1' as const;
